const updates = [
  { date: '2026-07-30', title: '《奥本海默》4K 修复版正式上线', type: '上新' },
  { date: '2026-07-29', title: '暑期档特别专题「科幻电影纵览」发布', type: '专题' },
  { date: '2026-07-28', title: '播放引擎升级，加载速度提升 40%', type: '系统' },
  { date: '2026-07-27', title: '《速度与激情》全系列上线，一次看过瘾', type: '上新' },
  { date: '2026-07-26', title: '新增夜间模式，护眼观影更舒适', type: '系统' },
  { date: '2026-07-25', title: '「宫崎骏动画全集」专题重磅推出', type: '专题' },
  { date: '2026-07-24', title: '《碟中谍》系列 1-7 部高清蓝光版入库', type: '上新' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-[900px] mx-auto">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading text-center">
          最新动态
        </h2>
        <p className="mt-2 text-sm text-foreground-600 text-center">
          天堂影视每日片库更新与平台动态
        </p>
        <div className="mt-8 relative pl-8 md:pl-10">
          <div className="absolute left-[11px] md:left-[15px] top-2 bottom-2 w-0.5 bg-background-200"></div>
          <div className="flex flex-col gap-5">
            {updates.map((item, i) => (
              <div key={i} className="relative">
                <div className="absolute -left-[31px] md:-left-[35px] top-1 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50"></div>
                <div className="flex flex-col sm:flex-row sm:items-center gap-1.5 sm:gap-4">
                  <div className="flex items-center gap-2">
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.date}</span>
                    <span className={`px-2 py-0.5 rounded text-[10px] font-medium whitespace-nowrap ${
                      item.type === '上新' ? 'bg-primary-100 text-primary-700' :
                      item.type === '专题' ? 'bg-accent-100 text-accent-700' :
                      'bg-secondary-100 text-secondary-700'
                    }`}>
                      {item.type}
                    </span>
                  </div>
                  <span className="text-sm text-foreground-800 font-medium">{item.title}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}